const USER_LOGIN = 'USER_LOGIN'
const USER_LOGOUT = 'USER_LOGOUT'
const USER_ERROR = 'USER_ERROR'
const INVALID_CREDENTIALS = 'INVALID_CREDENTIALS'
const LOGIN_ADVANCED = 'LOGIN_ADVANCED'
const LOGOUT_ADVANCED = 'LOGOUT_ADVANCED'
const LOADING_USER = 'LOADING_USER'
const PAUSE_LOADING_USER = 'PAUSE_LOADING_USER'
const CLEAR_ERRORS = 'CLEAR_USER_ERRORS'

export {
  LOADING_USER,
  USER_LOGIN,
  USER_LOGOUT,
  USER_ERROR,
  INVALID_CREDENTIALS,
  LOGIN_ADVANCED,
  LOGOUT_ADVANCED,
  PAUSE_LOADING_USER,
  CLEAR_ERRORS
}
